import {motion} from 'framer-motion';
import {getProgressPercentage} from '../../@utils/chapterMath';
import {CHAPTER_PROGRESS_TRANSITION} from '../ChaptersProgressBar';
import styles from './ChaptersProgressBarThumb.module.css';

const ChaptersProgressBarThumb = ({
    currentTime,
    duration,
    isHovered,
    isUserInteracting,
}: {
    currentTime: number;
    duration: number;
    isHovered: boolean;
    isUserInteracting: boolean;
}) => {
    const animTransition = isUserInteracting
        ? {duration: 0}
        : CHAPTER_PROGRESS_TRANSITION;

    return (
        <motion.div
            className={styles.customThumb}
            animate={{
                left: `${getProgressPercentage(currentTime, duration)}%`,
                translateX: '-50%',
                translateY: '-50%',
                scale: isHovered ? 1.5 : 1,
            }}
            transition={{
                ...animTransition,
            }}
            initial={false}
        />
    );
};

export default ChaptersProgressBarThumb;
